// extracted by mini-css-extract-plugin
module.exports = {"disabled":"SrPartnerStatCardV2--disabled--UsrYH","clickable":"SrPartnerStatCardV2--clickable--1mCm0","highlightYellowFadeIn":"SrPartnerStatCardV2--highlightYellowFadeIn--Tjf-g"};